import { forwardRef, type Ref, type SVGProps } from "react";
const IconFolderOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M4 27h24a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H15.5l-1.7-2.5a1 1 0 0 0-.9-.5H4a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2M4 6h8.4l1.4 2.1.6.9H28v16H4z" />
    <path d="M25 11H14.4a2 2 0 0 0-1.4.6L11.6 13H7a1 1 0 0 0 0 2h4.6a2 2 0 0 0 1.4-.6l1.4-1.4H25a1 1 0 0 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconFolderOutlineSVG);
ForwardRef.displayName = "IconFolderOutline";
export { ForwardRef as IconFolderOutline };
